function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './TextInput.css';
import React, { useEffect, useState } from 'react';
import { IconTranslate } from '../../../../../atoms/Icons/';
const TextInput = props => {
  const {
    required = false,
    value: contextValue = '',
    label = 'label',
    name = 'name',
    setTranslateValue,
    getTranslateValue,
    updateContext,
    rtl = false,
    type = 'text',
    relatedFieldName = '',
    patternInvalidMessage = 'validateError',
    validate,
    patternRegex,
    confirmField = '',
    isTranslateAvaible,
    validatePattern,
    onlyLetter = false
  } = props;
  const getTranslate = () => {
    if (setTranslateValue) setTranslateValue(relatedFieldName, contextValue);
  };
  const [inValid, setInValid] = useState(false);
  const onBlur = e => {
    if (confirmField.length) {
      required && setInValid(confirmField != contextValue);
      return;
    }
    let validateFlag = e.currentTarget.validity.valid;
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (patternRegex) validateFlag = patternRegex.test(e.target.value);
    if (type === 'email') validateFlag = !!e.target.value.match(isValidEmail);
    required && setInValid(!validateFlag);
  };
  const pattern = setTranslateValue ? '[A-Za-z]*' : undefined;
  const onChangeEvent = (value, validatePattern) => {
    updateContext({
      [name]: _objectSpread(_objectSpread({}, props), {}, {
        valid: required && validatePattern,
        value,
        validatePattern
      })
    });
  };
  useEffect(() => {
    if (validate) required && setInValid(!(contextValue && contextValue.length));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validate]);
  useEffect(() => {
    if (confirmField.length && contextValue.length) required && setInValid(confirmField != contextValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmField]);
  useEffect(() => {
    if (contextValue && contextValue) {
      const validateField = validatePattern !== undefined ? validatePattern : contextValue && contextValue.length;
      getTranslateValue && setInValid(!validateField);
      updateContext({
        [name]: _objectSpread(_objectSpread({}, props), {}, {
          valid: !!validateField
        })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue]);
  useEffect(() => {
    if (inValid) {
      // const validateField = validatePattern !== undefined ? validatePattern : contextValue && contextValue.length;

      updateContext({
        [name]: _objectSpread(_objectSpread({}, props), {}, {
          valid: !inValid
        })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inValid]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, /*#__PURE__*/React.createElement("label", {
    className: `body-small wiz__label `,
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "form-input__wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    name: name,
    type: type,
    className: `dynamic-pop-up__input ${inValid ? 'text-input__invalid' : ''} ${isTranslateAvaible && getTranslateValue && !contextValue ? 'disabled' : ''} `,
    placeholder: '',
    value: contextValue,
    onBlur: onBlur,
    pattern: pattern,
    onFocus: () => {
      isTranslateAvaible && getTranslateValue && getTranslateValue(name, relatedFieldName);
    },
    onChange: e => {
      const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      let validateFlag = e.currentTarget.validity.valid;
      if (patternRegex) validateFlag = patternRegex.test(e.target.value);
      if (type === 'email') validateFlag = !!e.target.value.match(isValidEmail);
      if ((onlyLetter || setTranslateValue) && /[^a-zA-Z]+$/.test(e.target.value)) return;
      if (isTranslateAvaible && getTranslateValue && !contextValue) return;
      onChangeEvent(e.currentTarget.value, validateFlag);
    },
    required: required
  }), setTranslateValue && /*#__PURE__*/React.createElement("span", {
    className: `form-label__icon ${!isTranslateAvaible ? 'disabled-icon' : ''}`,
    onClick: () => isTranslateAvaible && getTranslate()
  }, /*#__PURE__*/React.createElement(IconTranslate, null)), inValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error"
  }, patternInvalidMessage))));
};
const commonStyles = "c16f0mi1";
const rtlStyles = "r16uajfl";
const ltrStyles = "l5vc1ko";
export default TextInput;